// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__nKPS_","footer__link":"Footer_footer__link__3h_df","footer--dark":"Footer_footer--dark__DyGmU","footer--light":"Footer_footer--light__GdpO_"};